/**
 * MIRAK hover video: the muted, looping preview clips in MIRAK Showcase and
 * MIRAK Media Grid no longer autoplay continuously. On a mouse/trackpad
 * device the clip plays only while the pointer is over its tile. On a touch
 * device (no real hover) it instead plays while the tile is sufficiently
 * visible in the viewport, so scrolling still gives a working preview.
 * Either way, scrolling the tile out of view always force-pauses it — a
 * clip a visitor was hovering never keeps playing off-screen.
 */

const hoverCapable = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

function initHoverVideo(wrapper) {
  const video = wrapper.querySelector('video');
  if (!video) return;

  video.pause();

  const start = () => {
    video.play().catch(() => {});
  };

  const stop = () => {
    video.pause();
  };

  if (hoverCapable) {
    wrapper.addEventListener('mouseenter', start);
    wrapper.addEventListener('mouseleave', stop);
  }

  const visibilityObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) {
          stop();
        } else if (!hoverCapable) {
          start();
        }
      });
    },
    { threshold: 0.4 },
  );
  visibilityObserver.observe(wrapper);
}

document.querySelectorAll('[data-mirak-hover-video]').forEach(initHoverVideo);
